<template>
  <div style="padding:8px 4px;">
    <div v-if="loading" style="padding:32px 0;text-align:center;opacity:0.4;font-size:14px;">불러오는 중…</div>
    <div v-else-if="!hasRows" style="padding:32px 0;text-align:center;opacity:0.4;font-size:14px;">데이터가 없습니다.</div>
    <table v-else class="w-full" style="font-size:13px;border-collapse:collapse;">
      <thead>
        <tr style="border-bottom:2px solid rgba(0,0,0,0.08);">
          <th style="opacity:0.5;font-weight:600;padding:8px;text-align:left;">지역</th>
          <th style="opacity:0.5;font-weight:600;padding:8px;text-align:left;">소유자</th>
          <th style="opacity:0.5;font-weight:600;padding:8px;text-align:left;">유형</th>
          <th style="opacity:0.5;font-weight:600;padding:8px;text-align:right;">지분</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, idx) in rows" :key="idx" style="border-bottom:1px solid rgba(0,0,0,0.05);">
          <td style="padding:12px 8px;">{{ row.territory }}</td>
          <td style="padding:12px 8px;">{{ row.owner }}</td>
          <td style="padding:12px 8px;opacity:0.5;">{{ row.type }}</td>
          <td style="padding:12px 8px;text-align:right;font-variant-numeric:tabular-nums;">{{ row.ratio }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
function flatten(ownership) {
  const out = []
  const sections = ['general', 'mechanical', 'performance', 'synchronization']
  for (const section of sections) {
    const arr = ownership && ownership[section]
    if (!Array.isArray(arr)) continue
    for (const o of arr) {
      out.push({
        territory: territoryLabel(o),
        owner: o.owner || '—',
        type: section,
        ratio: typeof o.ratio === 'number' ? `${o.ratio}%` : '—',
      })
    }
  }
  return out
}

function territoryLabel(o) {
  const incl = o.territories || []
  const excl = o.territoriesNotIncluded || o.territoriesExcluded || []
  if (incl.length === 0 && excl.length === 0) return '전 세계'
  if (incl.length === 0 && excl.length > 0) return `전 세계 (${excl.join(', ')} 제외)`
  if (incl.length > 0 && excl.length === 0) return incl.join(', ')
  return `${incl.join(', ')} (${excl.join(', ')} 제외)`
}

export default {
  name: 'AssetOwnershipTab',
  props: {
    ownership: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  computed: {
    rows() { return flatten(this.ownership || {}) },
    hasRows() { return this.rows.length > 0 },
  },
}
</script>
